// extracted by mini-css-extract-plugin
export var container = "_23-0";
export var error = "_23-9";
export var label = "_23-5";
export var light = "_23-6";
export var md = "_23-3";
export var sm = "_23-2";
export var thin = "_23-8";
export var thinBold = "_23-7";
export var vertical = "_23-4";
export var xs = "_23-1";